import { render, staticRenderFns } from "./IconButtonPower.vue?vue&type=template&id=76fbff15&"
import script from "./IconButtonPower.vue?vue&type=script&lang=ts&"
export * from "./IconButtonPower.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports